// constants.js
export const BASE_URL = import.meta.env.DEV
  ? 'http://localhost:5001'
  : 'https://api-tn.licorne-academy.com';

export const PRODUCTS_URL = '/api/products';
export const USERS_URL = '/api/users';
export const ORDERS_URL = '/api/orders';
export const ORDERSOFFICE_URL = '/api/ordersOffice';
export const PAYPAL_URL = '/api/config/paypal';
export const UPLOAD_URL = '/api/upload';
